import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SubNationalDivision } from '../classes/models/sub-national-division';

@Injectable({
  providedIn: 'root'
})
export class SubNationalDivisionService {
  constructor(private http: HttpClient) {}

  public getSubNationalDivisions(
    query: { country?: string; abbreviation?: any } = {}
  ): Observable<SubNationalDivision[]> {
    return this.http.get<SubNationalDivision[]>(
      '/api/v2/public/data/divisions',
      { params: query }
    );
  }
}
